import { render } from "./EditarAdministrador.vue?vue&type=template&id=5e769d0e&scoped=true"
import script from "./EditarAdministrador.vue?vue&type=script&lang=js"
export * from "./EditarAdministrador.vue?vue&type=script&lang=js"

import "./EditarAdministrador.vue?vue&type=style&index=0&id=5e769d0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e769d0e"]])

export default __exports__